<script>
    import mixin from './../mixin';
    import constants from './../../constants';
    import SourceSet from './SourceSet.vue';

    export default {
        emits: ['removeFavorite'],
        mixins: [mixin],
        components: { SourceSet },
        data() {
            return {
                constants: constants
            }
        },
        props: {
            item: Object,
            titlePostfix: {
                type: String,
                default: 'Info & Tickets'
            },
            culture: {
                type: String,
                default: 'nl-NL'
            },
            favouriteTitleAdd: {
                type: String,
                default: 'Voeg toe aan favorieten'
            },
            favouriteTitleRemove: {
                type: String,
                default: 'Verwijder van favorieten'
            },
            isWishlist: {
                type: Boolean,
                default: false
            },
            dateSeparator: {
                type: String,
                default: 't/m'
            },
            fromLabel: {
                type: String,
                default: 'Vanaf'
            },
            freeLabel: {
                type: String,
                default: 'gratis'
            }
        },
        methods: {
            getLocation(event) {
                if (!event.targets) return null;
                if (event.targets.length === 1) {
                    return event.targets[0].name;
                } else {
                    if (event.targets.filter(target => target.isMainTarget).length) {
                        return event.targets.filter(target => target.isMainTarget)[0].name;
                    } else {
                        return event.targets.filter(target => target.id !== this.constants.targets.all)[0].name;
                    }
                }
            },
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="event is-flex" :title="item.performer + ' - ' + titlePostfix">
        <div class="event-info">
            <time v-if="item.start" class="event-date" :datetime="item.start">
                <span class="event-date-time mt-0" v-if="item.isExhibit && !item.lastEventEndDate && item.hasMultipleShows">{{ fromLabel }}</span>
                <span class="event-date-date">{{ toDateStr(item.start, culture) }}</span>
                <template v-if="item.isExhibit">
                    <template v-if="item.lastEventEndDate">
                        <span class="event-date-time mt-0">{{ dateSeparator }}</span>
                        <span class="event-date-date">
                            {{ toDateStr(item.lastEventEndDate, culture) }}
                        </span>
                    </template>
                </template>
                <span class="event-date-time" v-else>
                    {{ toTimeStr(item.start, culture) }}
                    <template v-if="item.end">
                        - {{ toTimeStr(item.end, culture) }}
                    </template>
                </span>
            </time>
            <div class="event-location" v-if="getLocation(item)">
                {{ getLocation(item) }}
            </div>
        </div>
        <source-set :imageSets="item.imageSets" class-name="event-image" alias="previewImage_" v-if="item.imageSets && item.imageSets.length" />
        <div class="event-content is-flex-grow-1">
            <button class="delete is-medium" v-if="isWishlist" :title="favouriteTitleRemove" @click.prevent="removeFromWishlist(item.id, item.performer, toDateStr(item.start,culture) + ' - ' + toTimeStr(item.start,culture))"></button>
            <span :class="['wishlist-add', 'has-text-link', 'wishlist-'+item.id, item.favourite ? 'is-active' : '']" :data-eventid="item.id"
                  :data-add="favouriteTitleAdd"
                  :data-remove="favouriteTitleRemove"
                  :data-datetime="item.start"
                  :title="item.favourite ? favouriteTitleRemove : favouriteTitleAdd"
                  :id="item.id"
                  :data-productiontitle="item.performer"
                  :data-productionsubtitle="toDateStr(item.start,culture) + ' - ' + toTimeStr(item.start,culture)"
                  @click.prevent.stop="addWishlistItem($event)" v-else>
                <span class="icon">
                    <i class="fa-regular fa-heart"></i>
                    <i class="fa-solid fa-heart is-hidden"></i>
                </span>
            </span>
            <div class="event-content-text">
                <div v-if="item.genres && item.genres.length" class="event-genres tags">
                    <span v-for="genre in item.genres" :key="genre.id" class="tag">{{ genre.name }}</span>
                </div>
                <h3 v-if="item.performer" class="title is-4 event-title mb-3">{{ item.performer }}</h3>
                <p v-if="item.title" class="block has-text-weight-medium event-subtitle mt-auto">{{ item.title }}</p>
                <p v-else-if="item.subTitle" class="block has-text-weight-medium event-subtitle mt-auto">{{ item.subTitle }}</p>
            </div>
            <span :class="['button', 'is-rounded', item.status.isClickable ? 'is-primary has-svg' : 'is-white has-border']"
                  v-if="item.status && item.status.buttonText && item.status.visible === true">
                <span>{{ item.status.buttonText }}</span>
                <span class="icon">
                    <img src="/svg/arrow.svg" alt="arrow right" width="12" height="10" loading="lazy">
                </span>
            </span>
            <span class="button is-rounded is-white has-border"
                  v-else-if="!item.status || item.status.visible !== false">
                <span>{{ freeLabel }}</span>
                <span class="icon">
                    <img src="/svg/arrow.svg" alt="arrow right" width="12" height="10" loading="lazy">
                </span>
            </span>
        </div>
        <div class="event-upsell" v-if="item.upsell">
            <img src="/svg/arrow-long.svg" alt="arrow long right" class="event-upsell-icon" width="46" height="12" loading="lazy">
            <img src="/svg/hexagon.svg" alt="hexagon" class="event-upsell-background" width="175" height="151" loading="lazy">
            <img src="/svg/hexagon.svg" alt="hexagon" class="event-upsell-background" width="175" height="151" loading="lazy">
            <p class="event-upsell-text has-text-weight-medium">{{ item.upsell.name }}</p>
        </div>
    </a>
</template>
